import { IWoocommerceProduct, IWoocommerceVariation, WoocommerceProductImageType } from "interfaces";
import { isNullOrWhitespace } from "helpers/productDetails";

export function findVariationForProductSelection(productVariations: IWoocommerceVariation[], currentProduct: IWoocommerceProduct) : IWoocommerceVariation | null {
    let foundProductVariation: IWoocommerceVariation | null = null;
    for (let i = 0; i < productVariations.length; i++) {
        let matchesSelectedOptions = true;
  
        if(!isNullOrWhitespace(productVariations[i].size) && !isNullOrWhitespace(currentProduct.selectedSize) &&
            productVariations[i].size.toLowerCase() !== currentProduct.selectedSize.toLowerCase()) {
          matchesSelectedOptions = false;
        }
        if(!isNullOrWhitespace(productVariations[i].color) && !isNullOrWhitespace(currentProduct.selectedColor) &&
          productVariations[i].color.toLowerCase() !== currentProduct.selectedColor.toLowerCase()) {
          matchesSelectedOptions = false;
        }
        if(!isNullOrWhitespace(productVariations[i].boardType) && !isNullOrWhitespace(currentProduct.selectedBoardType) &&
          productVariations[i].boardType.toLowerCase() !== currentProduct.selectedBoardType.toLowerCase()) {
          matchesSelectedOptions = false;
        }
        if(!isNullOrWhitespace(productVariations[i].lineLength) && !isNullOrWhitespace(currentProduct.selectedLineLength) &&
          productVariations[i].lineLength.toLowerCase() !== currentProduct.selectedLineLength.toLowerCase()) {
          matchesSelectedOptions = false;
        }
  
        if(matchesSelectedOptions)
          foundProductVariation = productVariations[i] as IWoocommerceVariation;
    }
    return foundProductVariation;
}

function hasImage(variation: IWoocommerceVariation): boolean {
  return variation.image != null && !isNullOrWhitespace(variation.image.src);
}

/**
 * Product photos are maintained per color in WooCommerce. Sizes commonly share
 * the same photo, so a missing image on the exact size must not prevent us from
 * using an image from another variation of the selected color.
 */
export function findImageForProductSelection(currentProduct: IWoocommerceProduct): WoocommerceProductImageType | null {
  const variations = currentProduct.productVariations ?? [];
  const selectedColor = currentProduct.selectedColor?.toLowerCase();

  if (!isNullOrWhitespace(selectedColor)) {
    const variationsForColor = variations.filter(variation =>
      !isNullOrWhitespace(variation.color) && variation.color.toLowerCase() === selectedColor
    );

    const exactVariation = findVariationForProductSelection(variationsForColor, currentProduct);
    if (exactVariation != null && hasImage(exactVariation)) {
      return exactVariation.image;
    }

    const colorVariationWithImage = variationsForColor.find(hasImage);
    if (colorVariationWithImage != null) {
      return colorVariationWithImage.image;
    }
  }

  return currentProduct.images?.[0] ?? null;
}
